import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { IntlTelInputComponent } from "intl-tel-input/angular";

import { RayalinaLoginFormComponent } from "./components/login-form/login-form.component";
import { RayalinaRegisterFormComponent } from "./components/register-form/register-form.component";
import { RayalinaSocialLoginComponent } from "./components/social-login/social-login.component";
import { SignupPageComponent } from "./pages/signup-page/signup-page.component";
import { LoginPageComponent } from "./pages/login-page/login-page.component";
import { CheckoutPageComponent } from "./pages/checkout/checkout.component";
import { RayalinaUssdMobileMoneyCheckoutComponent } from "./components/ussd-mobile-money-checkout/ussd-mobile-money-checkout.component";

@NgModule({
    imports: [CommonModule, ReactiveFormsModule, RouterModule, IntlTelInputComponent],
    declarations: [
        SignupPageComponent,
        LoginPageComponent,
        CheckoutPageComponent,
        RayalinaLoginFormComponent,
        RayalinaRegisterFormComponent,
        RayalinaSocialLoginComponent,
        RayalinaUssdMobileMoneyCheckoutComponent,
    ],
    exports: [SignupPageComponent, LoginPageComponent, CheckoutPageComponent],
})
export class AuthModule {}
